/* eslint-disable */
import { useState, useEffect, useRef } from 'react';
import dayjs from 'utils/dayjs';
import { Controller, useForm } from 'react-hook-form';
import { useSelector } from "react-redux";

import { Button, Divider, Modal, CardContent, Stack, TextField, Box, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

import { useEnumApi } from 'contexts/EnumApiContext';
import MainCard from 'components/MainCard';
import { getAttentionObservationsById, getEquipmentAlertsById, patchAttentionObservationsRelease } from 'components/axios/equipmentAlertsAxios';
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import FileDownloadIcon from 'components/FileDownloadIcon';
import { customFileAxios } from 'components/axios/customAxios';
import { Grid2, inputStyle } from "./CommonModule";
import { CustomMuiDatePicker } from 'components/date_picker/CustomMuiDatePicker';
import { useTranslation } from 'react-i18next';
import { isValidDateFormat } from 'components/date_picker/dateUtils';
import { PERMISSIONS } from 'config/permissions';
import PermissionButton from 'components/PermissionButton';

const AttentionObservationModal = ({alertId, onRefresh, type, isOpen=false}) => {
    const { t } = useTranslation();
    const { getEnumValueByEnumNameAndCode, getEnumValueByEnumName } = useEnumApi();
    const { name } = useSelector(state => state.user);

    const [open, setOpen] = useState(isOpen);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false); if (onRefresh)onRefresh();}

    const { openModal } = useModals();
    const handleAlertClick = (alertMessage) => {
        openModal(modals.alertModal, {
            onClose : () => {},
            message: alertMessage,
        });
    };

    const regexDate = RegExp(/^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/);
    
    // 수동 에러 제어를 위한 setError, clearErrors
    const { control, register , handleSubmit, setValue , getValues, setFocus, setError, clearErrors, formState : { errors } } = useForm({});
    const [equipmentAlert, setEquipmentAlert] = useState(null);
    const [attentionObservation, setAttentionObservation] = useState(null);
    const [observeStatus, setObserveStatus] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [fileLoading, setFileLoading] = useState(false);

    const nextID = useRef(1);
    const [inputFiles, setInputFiles] = useState([]);

    const today = new Date();
    const todayNum = dayjs(today).format("YYYYMMDD");

    useEffect(() =>{
      if (alertId) getAttentionObservation();
    },[alertId, isLoading]);

    const getAttentionObservation = () => {
      Promise.all([
        getEquipmentAlertsById(alertId).then((data)=>{
          setEquipmentAlert(data);
          return data;
        })
      ]).then((res)=>{
        if (res != null && res[0] != null && res[0].atentObserv != null) {
          getAttentionObservationsById(res[0].atentObserv.id).then((data2)=>{
            return data2;
          }).then((res2)=>{
            if (res2) {
              setAttentionObservation(res2);
              if (res2.status) {
                setObserveStatus(getEnumValueByEnumNameAndCode('AttentionObservationStatus',res2.status)?.[0]?.title);
              } else {
                setObserveStatus(getEnumValueByEnumNameAndCode('AttentionObservationStatus','R')?.[0]?.title);
              }
              setValue("plannedEndYmd",(res2.plannedEndYmd || null));
              setValue("remark",(res2.remark || null));
              setValue("regUser",(res2.regUser || name || null));
              setValue("regYmd",(res2.regYmd || dayjs().format("YYYY-MM-DD")));
              setValue("risUser",(res2.risUser || name || null));
              // setValue("risYmd",(res2.risYmd || null));

              if (res2.statusReport) {
                
                if (res2.statusReport.reportFiles) {
                  let inputFilesCopy = [];
                  nextID.current = 1;
                  for (var j=0;j<res2.statusReport.reportFiles.length;j++) {
                      const input = { 
                          id: nextID.current,
                          file: {},
                          rFile: res2.statusReport.reportFiles[j],
                      };
                      inputFilesCopy = [...inputFilesCopy, input]
                      nextID.current += 1;
                  }
                  setInputFiles(inputFilesCopy);
                }
              } else {
                setValue("reportYmd",null);
              }
            }
          })
        } else {
          setValue("regUser",(name || null));
          setValue("regYmd",(dayjs().format("YYYY-MM-DD")));
          setValue("risUser",(name || null));
        }
        setIsLoading(true);
      })
    }

    function addInputFile() {
      const input = { id: nextID.current, file: {}, rFile: null };
      setInputFiles([...inputFiles, input]);
      nextID.current += 1;
    }

    function deleteInputFile(index) {
        setInputFiles(inputFiles.filter(item => item.id !== index));
    }

    function handleInputFileChange(e, index) {
        if (index > inputFiles.length) return;
        let inputFilesCopy = [...inputFiles];
        inputFilesCopy[index].file = e.target.files[0];
        inputFilesCopy[index].rFile = null;
        setInputFiles(inputFilesCopy);
    }

    // =========================================================================
    // 💡 1. [주의관찰 해제] 버튼 전용 트랜잭션 함수 (수동 검사 수행)
    // =========================================================================
    const observationClear = async () => {
      // clearErrors(["risUser", "risYmd"]);
      clearErrors(["risUser"]);

      let risUser = getValues("risUser");
      // let risYmd = getValues("risYmd");
      let isFormValid = true;

      if (!risUser || risUser.trim() === "") {
        setError("risUser", { type: "manual", message: t('message.common.alert.observe.release.handler.input') });
        isFormValid = false;
      }

      if (!isFormValid) return; 

      const body = {
        id : attentionObservation.id,
        risUser : risUser
      };
console.log(body)

      openModal(modals.confirmModal, {
        onSubmit : (value) => {
          patchAttentionObservationsRelease(attentionObservation.id, body).then((res)=>{
            setIsLoading(false);
            if (onRefresh) onRefresh()
            handleAlertClick(t('message.common.alert.observe.release.complete'));
            handleClose();
          });
        },
        onClose : () => setFileLoading(false),
        message: t('message.common.alert.observe.release.handler.question'),
      });
      
      
    }

    // =========================================================================
    // 💡 2. [등록 / 수정] 버튼 전용 트랜잭션 함수 (handleSubmit을 통해 동작)
    // =========================================================================
    const onSubmit = (data, e) => {
      console.log(data)
      setFileLoading(true);

      if (data.plannedEndYmd === null || data.plannedEndYmd === '') {
        handleAlertClick(t('message.common.alert.observe.endYmd.input'));
        setFileLoading(false);
        return;
      }
      if (data.plannedEndYmd != null && data.plannedEndYmd != '' && !isValidDateFormat(data.plannedEndYmd)) {
        handleAlertClick(t('message.common.alert.observe.endYmd.input'));
        setFileLoading(false);
        return;
      }

      if (data.regYmd === null || data.regYmd === '') {
        handleAlertClick(t('message.common.alert.observe.startYmd.input'));
        setFileLoading(false);
        return;
      }
      if (data.regYmd != null && data.regYmd != '' && !isValidDateFormat(data.regYmd)) {
        handleAlertClick(t('message.common.alert.observe.startYmd.input'));
        setFileLoading(false);
        return;
      }
    
      let dto = {
        equipmentAlert : {id:alertId},
        equipment : {id:equipmentAlert.equipment.id},
        plannedEndYmd : data.plannedEndYmd,
        regUser : data.regUser,
        regYmd : data.regYmd,
        remark : data.remark,
      }

      let statusReport = {
      }

      let formData = new FormData();
      let fileCnt = 0;
      if(inputFiles) {
        for (var l=0;l<inputFiles.length;l++) {
            if (inputFiles[l].file && inputFiles[l].file.name) {
                formData.append("statusFiles", inputFiles[l].file);
                fileCnt++;
            }
        }
      }

      let rfileCnt = 0;
      if (inputFiles) {
        let rFiles = [];
        for (var a2=0;a2<inputFiles.length;a2++) {
            if (inputFiles[a2].rFile && inputFiles[a2].rFile.id) {
                rFiles.push({id : inputFiles[a2].rFile.id});
                rfileCnt++;
            }
        }
        statusReport.reportFiles = rFiles;
        dto.statusReport = statusReport;
      }

console.log(dto)
      
      if(type === undefined && (observeStatus === '' || attentionObservation?.status === 'V')) {
        formData.append("dto", new Blob([JSON.stringify(dto)], {type: "application/json"}) );
        openModal(modals.confirmModal, {
          onSubmit : (value) => {
            customFileAxios.post(`/api/attentionObservations`, formData).then((res)=>{
                handleAlertClick(t('message.common.alert.write.done'));
                setFileLoading(false);
                if (onRefresh) onRefresh()
                handleClose();
            }).catch((err)=>{
                setFileLoading(false);
                handleAlertClick(err.response?.data?.message || err.message || err.response?.data?.message);
            });
          },
          onClose : () => setFileLoading(false),
          message: t('message.common.alert.write.question'),
        });
      }

      if((type && type === "modify") && attentionObservation?.status === 'V') {
        dto.id = attentionObservation.id;
        statusReport.id = attentionObservation.statusReport?.id;

        formData.append("dto", new Blob([JSON.stringify(dto)], {type: "application/json"}) );
        openModal(modals.confirmModal, {
          onSubmit : (value) => {
            customFileAxios.patch(`/api/attentionObservations/${attentionObservation.id}`, formData).then((res)=>{
                handleAlertClick(t('message.common.alert.modify.done'));
                if (onRefresh) onRefresh()
                setFileLoading(false);
                handleClose();
            }).catch((err)=>{
                setFileLoading(false);
                handleAlertClick(err.response?.data?.message || err.message || err.response?.data?.message);
            });
          },
          onClose : () => setFileLoading(false),
          message: t('message.common.alert.modify.question'),
        });
      }

      if((type && type === "modify") && attentionObservation?.status === 'R') {
        delete dto.equipment;
        delete dto.equipmentAlert;
        delete dto.plannedEndYmd;
        delete dto.regUser;
        delete dto.regYmd;
        delete dto.remark;

        dto.id = attentionObservation.id;
        statusReport.id = attentionObservation.statusReport?.id;

        formData.append("dto", new Blob([JSON.stringify(dto)], {type: "application/json"}) );
        openModal(modals.confirmModal, {
          onSubmit : (value) => {
            customFileAxios.patch(`/api/attentionObservations/${attentionObservation.id}`, formData).then((res)=>{
                handleAlertClick(t('message.common.alert.modify.done'));
                if (onRefresh) onRefresh()
                setFileLoading(false);
                handleClose();
            }).catch((err)=>{
                setFileLoading(false);
                handleAlertClick(err.response?.data?.message || err.message);
            });
          },
          onClose : () => setFileLoading(false),
          message: t('message.common.alert.modify.question'),
        });
      }
    };

  if (equipmentAlert) {
    return (
    <>
      {type && type === 'icon' &&
      <PermissionButton
          permission={PERMISSIONS.ATTENTION_OBSERVATION_WRITE}
          variant="contained" onClick={handleOpen} style={{padding:"3px", minWidth:"unset"}} color="grey"
      >
          <span className="material-symbols-outlined" style={{color:"#fff"}}>content_paste_search</span>
      </PermissionButton>
      }
      {((type && type === "modify") || (type === undefined && observeStatus === '')) &&
      <PermissionButton
        permission={PERMISSIONS.ATTENTION_OBSERVATION_WRITE}
        className="pop_style_btn"
        type="button"
        onClick={handleOpen}
        style={{
          height: "35px",
          minHeight: "35px",
          marginLeft: "3px",
          marginRight: "3px"
        }}
      >
        <span>
          {type === "modify"
            ? t('message.common.btn.observe.management')
            : t('message.common.btn.observe')}
        </span>

        <svg
          width="15"
          height="15"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
          style={{
            display: "block",
            flexShrink: 0
          }}
        >
          <path d="M7 17 17 7M8 7h9v9" />
        </svg>
      </PermissionButton>
      }

      <Modal className="pop_box pop_box1 renew_pop_box attention_detail_renew_pop" open={open} onClose={handleClose}>
        <MainCard modal darkTitle content={false} sx={{ width: 650 }}>
          <div className="modal-header" style={{color:"#f0f002"}}>⚠️ {t('message.common.title.register.observation.target')}</div>

          <form onSubmit={handleSubmit(onSubmit)}>
            <CardContent className="attention_detail_body" sx={{ maxHeight: "70vh", overflowY: "auto" }}>
                <div className="attention_detail_section">
                <Grid2>
                  <Box sx={{ flex: 1 }}>
                    <Typography sx={{ fontSize: "0.85rem", color: "#a0aec0", mb: 1 }}>{t('message.common.subtitle.observe.write.date')}</Typography>
                    {attentionObservation?.status === 'R' ? 
                    <div className="attention_readonly_value">{attentionObservation.regYmd}</div> : 
                    <Controller
                      control={control}
                      name="regYmd"
                      rules={{ required: t('message.common.error.text.observe.write.date.input') }}
                      render={({ field , fieldState }) => (
                        <CustomMuiDatePicker style={{width:"96%", textAlign:"center"}} field={field} fieldState={fieldState} />
                      )}
                    />
                    }
                  </Box>

                  <Box sx={{ flex: 1 }}>
                    <Typography sx={{ fontSize: "0.85rem", color: "#a0aec0", mb: 1 }}>{t('message.common.subtitle.observe.regUser')} ({t('message.common.subtitle.managerName')})</Typography>
                    {attentionObservation?.status === 'R' ? 
                    <div className="attention_readonly_value">{attentionObservation.regUser}</div> : 
                    <TextField fullWidth placeholder={t('message.common.text.placeholder.enter.name')} {...register("regUser", { required : t('message.common.error.text.observe.writer.input') })} sx={inputStyle} error={!!errors.regUser} helperText={errors.regUser?.message} />
                    }
                  </Box>
                </Grid2>
                </div>

                <div className="attention_detail_section attention_detail_main_fields">
                <Box sx={{ flex: 1 }}>
                  <Typography sx={{ fontSize: "0.85rem", color: "#a0aec0", mb: 1 }}>{t('message.common.subtitle.observe.scheduled.endDate')}</Typography>
                  {attentionObservation?.status === 'R' ? 
                  <div className="attention_readonly_value">{attentionObservation.endYmd}</div> : 
                  <Controller
                    control={control}
                    name="plannedEndYmd"
                    rules={{ required: t('message.common.error.text.observe.scheduled.endDate.input') }}
                    render={({ field , fieldState }) => (
                      <CustomMuiDatePicker field={field} fieldState={fieldState} />
                    )}
                  />
                  }
                </Box>
                
                <Box sx={{ flex: 1 }}>
                  <Typography sx={{ fontSize: "0.85rem", color: "#a0aec0", mb: 1 }}>{t('message.common.subtitle.observe.detail')}</Typography>
                  {attentionObservation?.status === 'R' ? 
                  <div className="attention_readonly_value">{attentionObservation.remark}</div> : 
                  <TextField multiline rows={4} fullWidth placeholder={t('message.common.text.placeholder.detail.input')} {...register("remark", { required : t('message.common.error.text.observe.detail.input') })} sx={inputStyle} error={!!errors.remark} helperText={errors.remark?.message} />
                  }
                </Box>
                </div>

                {observeStatus && 
                <div className="attention_detail_section">
                <Grid2>
                  <Box sx={{ flex: 1 }}>
                    <Typography sx={{ fontSize: "0.85rem", color: "#a0aec0", mb: 1 }}>{t('message.common.subtitle.release.handler')}</Typography>
                    {attentionObservation?.status === 'R' ? 
                    <div className="attention_readonly_value">{attentionObservation.risUser}</div> : 
                    <TextField fullWidth sx={inputStyle}
                      {...register("risUser")} 
                      error={!!errors.risUser} helperText={errors.risUser?.message}
                    />
                    }
                  </Box>

                  <Box sx={{ flex: 1 }}>
                    <Typography sx={{ fontSize: "0.85rem", color: "#a0aec0", mb: 1 }}>{t('message.common.subtitle.status')}</Typography>
                    <div className="attention_status_row">
                      <span className="attention_status_value">{observeStatus}</span>
                      {attentionObservation?.status === 'V' &&
                      <PermissionButton
                          permission={PERMISSIONS.ATTENTION_OBSERVATION_RELEASE}
                          variant="contained" color="warning" style={{padding:"4px 12px", color:"#fff"}} onClick={observationClear}
                      >
                          {t('message.common.subtitle.observe.release')}
                      </PermissionButton>
                      }
                    </div>
                  </Box>
                </Grid2>
                </div>
                }

                <div className="attention_detail_section attention_detail_attachments">
                <Box sx={{ flex: 1 }}>
                  <Typography sx={{ fontSize: "0.85rem", color: "#a0aec0", mb: 1 }}>
                    {t('message.common.subtitle.status.report.file')} ({t('message.common.tabTitle.picture.data')})
                    <AddCircleOutlineIcon className="attention_file_add" fontSize="small" style={{cursor:"pointer", marginTop:"-3px", marginLeft:"5px"}} onClick={addInputFile}>+</AddCircleOutlineIcon>
                  </Typography>
                  
                  {inputFiles && inputFiles.map(function(item, index) {
                  return (
                  <div key={index} className="attention_file_row">
                      <input type="file" value={''} className="file-input" style={{width:"200px"}} onChange={e => handleInputFileChange(e, index)} />
                      { inputFiles[index] ? (
                          <RemoveCircleOutlineIcon fontSize="small" style={{cursor:"pointer", marginLeft:"5px"}} onClick={() => deleteInputFile(item.id)}>-</RemoveCircleOutlineIcon>
                      ) : ''}
                      {(item.file && item.file.name) ? item.file.name : (item.rFile && item.rFile.id && <><FileDownloadIcon file={item.rFile} viewFileName={true} /></>)}
                  </div>
                  )
                  })}
                </Box>
                </div>
            </CardContent>

            <Divider />

            <Stack className="attention_detail_footer" direction="row" justifyContent="flex-end" spacing={1} sx={{ p: 2 }}>
              {(type && type === "modify") &&
              <LoadingButton type="submit" variant="contained" size="small" color="primary" loading={fileLoading}>{t('message.common.btn.modify')}</LoadingButton>
              }
              {(attentionObservation === null && (observeStatus === '' || attentionObservation?.status === 'V')) &&
              <LoadingButton type="submit" variant="contained" size="small" color="primary" loading={fileLoading}>{t('message.common.btn.write')}</LoadingButton>
              }
              <Button variant="contained" className="attention_detail_cancel" onClick={handleClose}>{t('message.common.btn.cancel')}</Button>
            </Stack>
          </form>
        </MainCard>
      </Modal>
    </>
    );
  }
};

export default AttentionObservationModal;